module.exports = __webpack_public_path__ + "fonts/32d05f11b890b97176610001caaedb8b.txt";